/**
 * Converts a 24-hour hour value to a 12-hour hour value.
 * @param {number} hour24 - The hour value (0-23) in 24-hour format.
 * @returns {number|string} The corresponding hour value (1-12) in 12-hour format, or "null" if the input is invalid.
 */
export function convertTo12Hour(hour24: number): number | null {
    // Ensure the input is a valid number between 0 and 23
    if (hour24 < 0 || hour24 > 23) {
        return null;
    }

    // Convert to 12-hour format
    let hour12 = hour24 % 12;
    if (hour12 === 0) {
        hour12 = 12; // 12 AM or 12 PM
    }

    return hour12;
}
